import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import zeplinColor from '../../../../../../theme/Color';

export const CalendarHeader = ({
  getTimezoneDisplayText,
  dateColumns,
}: {
  getTimezoneDisplayText: () => string;
  dateColumns: {
    date: dayjs.Dayjs;
    dayName: string;
    dayNumber: string;
    fullFormat: string;
    isToday: boolean;
    isSelected: boolean;
  }[];
}) => {
  const timeColumnWidth = 150;
  const dateColumnWidth = 184;
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'sticky',
        top: 0,
        zIndex: 101,
        backgroundColor: zeplinColor.Neutral1,
        minWidth: 'max-content',
      }}
    >
      <Box
        sx={{
          width: `${timeColumnWidth}px`,
          minWidth: `${timeColumnWidth}px`,
          borderRight: `1px solid ${zeplinColor.Neutral5}`,
          backgroundColor: zeplinColor.Neutral1,
          position: 'sticky',
          left: 0,
          padding: '16px 16px 5px 16px',
        }}
      >
        <Box
          sx={{
            backgroundColor: zeplinColor.Neutral3,
            padding: { xs: '12px 4px', xl: '14px 8px' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '14px',
            position: 'relative',
          }}
        >
          <Typography
            variant='responsiveBody3'
            sx={{
              color: zeplinColor.BasicBlack,
              lineHeight: '29.3px',
              position: 'relative',
            }}
          >
            {getTimezoneDisplayText()}
          </Typography>
        </Box>
      </Box>

      {dateColumns.map((dateCol, index) => {
        return (
          <Box
            key={dateCol.date.format('YYYY-MM-DD')}
            sx={{
              minWidth: `${dateColumnWidth}px`,
              flex: 1,
              borderRight:
                index === dateColumns.length - 1 ? 'none' : `1px solid ${zeplinColor.Neutral5}`,
              backgroundColor: zeplinColor.Neutral1,

              padding: '16px 16px 5px 16px',
            }}
          >
            <Box
              sx={{
                padding: { xs: '12px 4px', xl: '14px 8px' },
                borderRadius: '14px',
                display: 'flex',
                backgroundColor: dateCol.isSelected ? zeplinColor.BasicBlack : zeplinColor.Neutral3,
                gap: '12px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                variant='caption'
                sx={{
                  color: dateCol.isSelected ? zeplinColor.Neutral1 : zeplinColor.BasicBlack,
                }}
              >
                {dateCol.dayName.toUpperCase()}
              </Typography>
              <Typography
                variant='responsiveDisplay6'
                sx={{
                  color: dateCol.isSelected ? zeplinColor.Neutral3 : zeplinColor.BasicBlack,
                }}
              >
                {dateCol.dayNumber}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
